import React, { useState, useEffect } from 'react';
import { Modal, message } from 'antd';

interface ProductUsageModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (usage: string, orderType: string) => void;
  currentUsage: string;
  currentOrderType: string;
  itemSeq: number;
}

const USAGE_OPTIONS = [
  { value: '1', label: '1 - RAIN WEAR(雨衣)' },
  { value: '2', label: '2 - DOWN JACKET(羽絨外套)' },
  { value: '3', label: '3 - SKI WEAR(滑雪衣)' },
  { value: '4', label: '4 - SPORTS WEAR(運動服)' },
  { value: '5', label: '5 - CASUAL WEAR(休閒服)' },
  { value: '6', label: '6 - UNIFORM(制服)' },
  { value: '7', label: '7 - WORK WEAR(工作服)' },
  { value: '8', label: '8 - OUTDOOR(戶外用品)' },
  { value: '9', label: '9 - BAG(袋類)' },
  { value: '10', label: '10 - TENT(帳篷)' },
  { value: '11', label: '11 - UMBRELLA(傘)' },
  { value: '12', label: '12 - SHOE(鞋)' },
  { value: '13', label: '13 - LINING(裡布)' },
  { value: '14', label: '14 - INTERLINING(襯布)' },
  { value: '15', label: '15 - CURTAIN(窗簾)' },
  { value: '16', label: '16 - BEDDING(寢具)' },
  { value: '17', label: '17 - OTHER(其他)' },
];

const ORDER_TYPE_OPTIONS = [
  { value: '1', label: '1 - 報價單(Quotation)' },
  { value: '2', label: '2 - Sample(樣品單)' },
  { value: '3', label: '3 - 訂單(Order)' },
];

const selectStyle: React.CSSProperties = {
  width: '100%',
  height: 32,
  fontSize: 13,
  border: '1px solid #d9d9d9',
  borderRadius: 4,
  padding: '0 8px',
  background: '#fff',
};

const ProductUsageModal: React.FC<ProductUsageModalProps> = ({
  open, onClose, onSave, currentUsage, currentOrderType, itemSeq,
}) => {
  const [usage, setUsage] = useState('');
  const [orderType, setOrderType] = useState('');

  // Reset when modal opens
  useEffect(() => {
    if (open) {
      setUsage(currentUsage || '');
      setOrderType(currentOrderType || '');
    }
  }, [open, currentUsage, currentOrderType]);

  const handleOk = () => {
    // BR-V29: order type cannot be empty
    if (!orderType.trim()) {
      message.error('訂單種類不可空白!');
      return;
    }

    onSave(usage, orderType);
  };

  return (
    <Modal
      title={`產品用途 - 項次 ${itemSeq}`}
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      width={450}
      okText="確認"
      cancelText="取消"
      destroyOnClose
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: '8px 0' }}>
        <div>
          <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 500 }}>
            產品用途 (FC111_27)
          </label>
          <select
            style={selectStyle}
            value={usage}
            onChange={e => setUsage(e.target.value)}
          >
            <option value="">-- 請選擇 --</option>
            {USAGE_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 500 }}>
            <span style={{ color: '#ff4d4f', fontWeight: 700 }}>* </span>
            訂單種類 (FC111_28)
          </label>
          <select
            style={selectStyle}
            value={orderType}
            onChange={e => setOrderType(e.target.value)}
          >
            <option value="">-- 請選擇 --</option>
            {ORDER_TYPE_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(ProductUsageModal);
